export default "__VITE_ASSET__1bcfaaf0__"